// ============================================
// APPSTLE SELLING PLAN CONFIGURATION
// Only two live plans remain (verified via Admin API). The 2-month plan is DELETED;
// the old Loop plan IDs are dead and have been removed.
// ============================================
const APPSTLE_SELLING_PLANS = {
  '1': '691420332355',  // 1 Monthly Subscription (~25% off)
  '2': '691420332355',  // 2-month plan deleted → fall back to monthly plan
  '3': '691420397891',  // 3 Monthly Subscription (~33% off)
};

let currentSellingPlanId = APPSTLE_SELLING_PLANS['1'];
let productData = null;
let subscriptionDiscount = 0; // percentage discount from selling plan

// ============================================
// BUNDLE OPTION TOGGLE (Subscribe & Save vs One-Time)
// ============================================
document.addEventListener('change', function (e) {
  const clicked = e.target.closest('.bundle-option input[name="bundle-choice"]');
  if (!clicked) return;

  const selectedOption = e.target.closest('.bundle-option');
  if (!selectedOption) return;

  document.querySelectorAll('.bundle-option').forEach((opt) => {
    opt.classList.remove('active');
  });
  selectedOption.classList.add('active');

  if (selectedOption.classList.contains('subscribe_save')) {
    selectedOption.closest(".variant-wrapper").classList.add("subscribe_save_active");
    selectedOption.closest(".variant-wrapper").classList.remove("onetime_active");
    console.log('✅ Switched to Subscribe & Save');
  } else if (selectedOption.classList.contains('one_time')) {
    selectedOption.closest(".variant-wrapper").classList.remove("subscribe_save_active");
    selectedOption.closest(".variant-wrapper").classList.add("onetime_active");

    const oneTimeDetails = getOneTimePriceDetails();
    if (oneTimeDetails) {
      getOneTimeCustomButton(selectedOption, oneTimeDetails.html, oneTimeDetails.price);
    }
    console.log('✅ Switched to One Time Purchase');
  }

  updateCurrentPrice();
  updateSellingPlanBasedOnQuantity();
});


// ============================================
// QUANTITY SELECTION → SELLING PLAN UPDATE
// ============================================
function updateSellingPlanBasedOnQuantity() {
  setTimeout(() => {
    const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
    if (!checkedRadio) {
      console.warn("⚠️ No Quantity option selected");
      return;
    }

    const quantityValue = checkedRadio.value.trim();
    console.log("🟢 Selected Quantity:", quantityValue);

    const match = quantityValue.match(/^(\d+)/);
    if (!match) return;

    const number = match[1];
    console.log("📦 Extracted number:", number);
    activateVariantWrappers_multicolor(number);
    updateFlavourProperties();

    // Set the current selling plan ID based on quantity
    if (APPSTLE_SELLING_PLANS[number]) {
      currentSellingPlanId = APPSTLE_SELLING_PLANS[number];
      console.log(`✅ Selling plan set to ${currentSellingPlanId} for quantity ${number}`);
    } else {
      console.warn("⚠️ No selling plan found for quantity:", number);
    }

    updateCurrentPrice(number);
    activateGiftsUpTo(number);

    const oneTimeDetails = getOneTimePriceDetails();
    var selectedOptionOne_new = document.querySelector(".bundle-option.one_time");
    if (oneTimeDetails) {
      getOneTimeCustomButton(selectedOptionOne_new, oneTimeDetails.html, oneTimeDetails.price);
    }
  }, 50);
}


// ============================================
// INITIALIZATION — replaces waitForAppstleWidget
// ============================================
function initOfferWidget() {
  // Parse product data for price calculations
  const prodJsonEl = document.getElementById("custom-prod-data-json");
  if (prodJsonEl) {
    try {
      productData = JSON.parse(prodJsonEl.textContent);

      // Extract subscription discount from selling plan groups
      if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
        const group = productData.selling_plan_groups[0];
        if (group && group.selling_plans && group.selling_plans.length > 0) {
          const firstPlan = group.selling_plans[0];
          if (firstPlan.price_adjustments && firstPlan.price_adjustments.length > 0) {
            const adj = firstPlan.price_adjustments[0];
            if (adj.value_type === 'percentage') {
              subscriptionDiscount = adj.value;
            }
          }
        }
      }
      console.log("🟢 Product data loaded, subscription discount:", subscriptionDiscount + "%");
    } catch (err) {
      console.error("❌ Failed to parse product data:", err);
    }
  }

  // Enable ALL variant wrappers that have the disable class
  document.querySelectorAll(".variant-wrapper.variant-wrapper-disable").forEach(wrapper => {
    wrapper.classList.remove("variant-wrapper-disable");
    console.log("🟢 Enabled variant wrapper");
  });

  console.log("🟢 Loop offer widget initialized");
  updateSellingPlanBasedOnQuantity();
}


// ============================================
// GIFTS
// ============================================
function activateGiftsUpTo(count) {
  const gifts = document.querySelectorAll(".gifts-wrapper .gift-item-wrap");
  if (!gifts.length) return;

  gifts.forEach(gift => gift.classList.remove("active"));

  if (count >= gifts.length || count >= 3) {
    gifts.forEach(gift => gift.classList.add("active"));
  } else {
    gifts.forEach((gift, i) => {
      if (i < count) gift.classList.add("active");
    });
  }
}


// ============================================
// PRICE DISPLAY — reads exact prices from selling plan allocations
// ============================================

// Get a representative variant for the current quantity tier
function getVariantForTier(quantityValue) {
  if (!productData || !productData.variants) return null;
  // Match any variant with the selected quantity option (e.g. "1 Month Supply")
  return productData.variants.find(v =>
    v.option2 && v.option2.toLowerCase() === quantityValue.toLowerCase()
  ) || productData.variants[0];
}

// Get the one-time (no selling plan) price for a variant — in pounds
function getOneTimePrice(variant) {
  if (!variant) return 0;
  return variant.price / 100;
}

// Get the subscription price from a variant's selling plan allocation — in pounds
function getSubscriptionPrice(variant, sellingPlanId) {
  if (!variant || !variant.selling_plan_allocations) return null;
  const alloc = variant.selling_plan_allocations.find(a =>
    String(a.selling_plan_id) === String(sellingPlanId)
  );
  return alloc ? alloc.price / 100 : null;
}

// Get the compare-at price from a variant's selling plan allocation — in pounds
function getCompareAtPrice(variant, sellingPlanId) {
  if (!variant || !variant.selling_plan_allocations) return null;
  const alloc = variant.selling_plan_allocations.find(a =>
    String(a.selling_plan_id) === String(sellingPlanId)
  );
  return alloc ? alloc.compare_at_price / 100 : null;
}

function updateCurrentPrice(number) {
  handleBundleSelection();

  if (!productData) return;

  const qty = parseInt(number, 10) || 1;

  // Get the selected quantity text (e.g. "1 Month Supply")
  const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  if (!checkedRadio) return;
  const quantityValue = checkedRadio.value.trim();

  // Find a representative variant for this tier
  const variant = getVariantForTier(quantityValue);
  if (!variant) return;

  const isSubscription = document.querySelector('.bundle-option.subscribe_save.active') !== null;
  const sellingPlanId = APPSTLE_SELLING_PLANS[String(qty)];

  let unitPrice, comparePrice, total, originalTotal, savings;

  if (isSubscription && sellingPlanId) {
    unitPrice = getSubscriptionPrice(variant, sellingPlanId);
    comparePrice = getCompareAtPrice(variant, sellingPlanId);
    if (unitPrice === null) unitPrice = getOneTimePrice(variant);
    if (comparePrice === null) comparePrice = getOneTimePrice(variant);
  } else {
    unitPrice = getOneTimePrice(variant);
    comparePrice = unitPrice;
  }

  total = (unitPrice * qty).toFixed(2);
  originalTotal = (comparePrice * qty).toFixed(2);
  savings = (originalTotal - total).toFixed(2);

  // Update .curr-prc
  const currPrcEl = document.querySelector('.curr-prc');
  const saveBadgAmt = document.querySelector('.save-badge-amt');
  const saveBadgeCompare = document.querySelector(".save-badge-off-compare");

  if (currPrcEl) {
    currPrcEl.textContent = `  £${total}`;
    console.log("💰 Price updated:", `£${total} (unit: £${unitPrice.toFixed(2)}, qty: ${qty})`);
  }

  updateSavePerBundle(`£${unitPrice.toFixed(2)}`);

  if (isSubscription && saveBadgAmt) {
    saveBadgeCompare.innerHTML = `<div class="price-compare-wrapper">
                  <span class="price-sale transcy-money">(£${total})</span>
                  <span class="price-compare transcy-money">£${originalTotal}</span>
                </div>`;

    updateSavingBadge(savings);
    saveBadgAmt.textContent = ` (£${unitPrice.toFixed(2)} Per Tub)`;
  }
}


function updateSavingBadge(saveAmount) {
  const checkedInput = document.querySelector('input[name="Quantity"]:checked');
  const allQuantityInputs = document.querySelectorAll('input[name="Quantity"]');

  allQuantityInputs.forEach(eachInput => {
    const nextLabel = eachInput.nextElementSibling;
    const badge = nextLabel?.querySelector(".s_sub_saving_badge");
    if (badge) badge.classList.add("hidden");
  });

  if (checkedInput) {
    const nextLabel = checkedInput.nextElementSibling;
    const badge = nextLabel?.querySelector(".s_sub_saving_badge");
    if (badge) {
      badge.classList.remove("hidden");
      const money = badge.querySelector(".money");
      if (money) money.textContent = `£${saveAmount}`;
    }
  }
}


function updateSavePerBundle(priceText) {
  const updatesave_checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  if (!updatesave_checkedRadio) {
    console.warn("⚠️ No Quantity option selected");
    return;
  }

  const updatesave_quantityValue = updatesave_checkedRadio.value.trim();
  const updatesave_match = updatesave_quantityValue.match(/^(\d+)/);
  if (!updatesave_match) return;

  const updatesave_number = updatesave_match[1];
  const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ""));
  const pricePerBundle = (numericPrice / updatesave_number).toFixed(2);
  console.log("📦 pricePerBundle:", pricePerBundle);
}


// ============================================
// QUANTITY CHANGE LISTENER
// ============================================
document.addEventListener("change", function (event) {
  if (event.target.name === "Quantity") {
    updateSellingPlanBasedOnQuantity();
  }
});

// Run on initial load — no widget dependency
if (document.readyState === 'loading') {
  window.addEventListener("DOMContentLoaded", initOfferWidget);
} else {
  // DOM already parsed (e.g. script loaded late)
  initOfferWidget();
}


// ============================================
// ONE-TIME PRICE HELPERS — uses product variant data
// ============================================
function getOneTimePriceDetails() {
  if (!productData || !productData.variants) return null;

  // Get the variant for the currently selected quantity tier
  const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  const quantityValue = checkedRadio ? checkedRadio.value.trim() : null;
  const variant = quantityValue ? getVariantForTier(quantityValue) : productData.variants[0];
  if (!variant) return null;

  const price = getOneTimePrice(variant);
  if (!price || isNaN(price)) return null;

  const html = `<span class="transcy-money">£${price.toFixed(2)}</span>`;
  return { html, price };
}

function getOneTimeCustomButton(selectedOptionOne, html, price) {
  if (!selectedOptionOne) return;

  const compareBadge = selectedOptionOne.querySelector(".save-badge-off-compare");
  const checked = document.querySelector('input[name="Quantity"]:checked');
  if (!checked) return;

  const match = checked.value.match(/(\d+)/);
  const number = match ? Number(match[1]) : null;
  if (!number || isNaN(price)) return;

  console.log("onetime per tub", number);

  const saveBadgeOff = selectedOptionOne.querySelector(".save-badge-off .save-badge-amt");
  if (saveBadgeOff) {
    saveBadgeOff.textContent = ` (£${price.toFixed(2)} Per Tub)`;
  }
  if (compareBadge) {
    compareBadge.innerHTML = `<div class="price-compare-wrapper">
                  <span class="price-sale transcy-money">(£${(price * number).toFixed(2)})</span>
                  <span class="price-compare transcy-money"></span>
                </div>`;
  }
}


// ============================================
// MULTI-FLAVOUR SELECTION
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  const flavourSnippets = document.querySelectorAll('.custom-flavour-snippet');

  flavourSnippets.forEach(snippet => {
    snippet.addEventListener('click', e => {
      const label = e.target.closest('label.qty-image-element-wrap');
      if (!label) return;

      const wrapper = label.closest('.variant-wrapper');
      if (!wrapper) return;

      wrapper.querySelectorAll('label').forEach(l => l.classList.remove('active'));
      label.classList.add('active');

      const data = {};
      snippet.querySelectorAll('.variant-wrapper.active').forEach(activeWrapper => {
        const boxQty = activeWrapper.getAttribute('data-boxqty');
        const activeLabel = activeWrapper.querySelector('label.active');
        const flavour = activeLabel ? activeLabel.getAttribute('data-flavour') : null;

        if (boxQty && flavour) {
          data[boxQty] = flavour;
        }
      });

      console.log(data);
      updateFlavourProperties();
    });
  });
});


function activateVariantWrappers_multicolor(count) {
  const wrappers = document.querySelectorAll('.custom-flavour-snippet .variant-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper, index) => {
    if (index < count) {
      wrapper.classList.add('active');
    } else {
      wrapper.classList.remove('active');
    }
  });
}


function updateFlavourProperties() {
  // Placeholder — flavour properties are handled via cart add
}


// ============================================
// CUSTOM ADD TO CART — uses Loop selling plan IDs directly
// ============================================
function getSelectedVariantData() {
  const prodJson_multi = document.getElementById("custom-prod-data-json");
  const productData_multi = JSON.parse(prodJson_multi.textContent);

  // 1. Get selected Quantity
  const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  const quantityValue = checkedRadio ? checkedRadio.value.trim() : null;

  // 2. Use Loop selling plan ID from our mapping
  const sellingPlanId = currentSellingPlanId;

  // 3. Collect selected flavours
  const selectedFlavours = [];
  document.querySelectorAll('.variant-wrapper.active').forEach(wrapper => {
    const activeLabel = wrapper.querySelector('label.active');
    const flavour = activeLabel ? activeLabel.getAttribute('data-flavour') : null;
    if (flavour) selectedFlavours.push(flavour);
  });

  // 4. Match flavour + quantity to variant
  const matchedData = selectedFlavours.map(flavour => {
    const variant = productData_multi.variants.find(v =>
      v.option1.toLowerCase() === flavour.toLowerCase() &&
      v.option2.toLowerCase() === quantityValue.toLowerCase()
    );

    return {
      flavour: flavour,
      quantity: quantityValue,
      sellingPlanId: sellingPlanId,
      variantId: variant ? variant.id : null
    };
  });

  return matchedData;
}


async function addSelectedVariantsToCart() {
  const selectedData = getSelectedVariantData();

  if (!selectedData || selectedData.length === 0) {
    console.error("No selected variants found");
    return;
  }

  const grouped = {};

  selectedData.forEach(item => {
    if (!item.variantId) return;

    const key = item.variantId;

    if (!grouped[key]) {
      grouped[key] = {
        id: item.variantId,
        quantity: 0,
        selling_plan: item.sellingPlanId,
        flavour: item.flavour,
        qtyText: item.quantity
      };
    }

    grouped[key].quantity += 1;
  });

  var curr_Sel_opt = document.querySelector(".bundle-option.active").dataset.vall;

  const items = Object.values(grouped).map(item => {
    const obj = {
      id: item.id,
      quantity: item.quantity
    };

    // Add selling_plan only if subscription selected
    if (curr_Sel_opt === "subs_and_save") {
      obj.selling_plan = item.selling_plan;
    }

    return obj;
  });

  if (items.length === 0) return;
  console.log("🛒 Adding to cart:", curr_Sel_opt, items);

  try {
    const response = await fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    const data = await response.json();
    console.log("Added to cart:", data);
    refreshCart();

  } catch (error) {
    console.error("Add to cart error:", error);
  }
}


const addToCartBtn = document.querySelector('.custom_Add_to_cart_button');
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', addSelectedVariantsToCart);
}


// ============================================
// CART DRAWER REFRESH
// ============================================
function refreshCart() {
  fetch('/cart?section_id=cart-drawer', {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('cart-drawer');
    const existingDrawer = document.querySelector('cart-drawer');

    if (newDrawer && existingDrawer) {
      existingDrawer.innerHTML = newDrawer.innerHTML;
      existingDrawer.classList.add("active");
      existingDrawer.classList.remove("is-empty");
    }
  })
  .catch(error => {
    console.error("Cart drawer error:", error);
  });
}


// ============================================
// MAIN CART PAGE — CLEAR CART
// ============================================
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".main-cart_item_remove");
  if (!btn) return;

  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(res => res.json())
    .then(data => {
      console.log("Cart cleared:", data);
      window.location.href = "/products/juici-2-in-1-booty-beauty-blend";
    })
    .catch(err => {
      console.error("Error:", err);
    });
});


// ============================================
// HANDLE BUNDLE SELECTION — no Appstle dependency
// ============================================
function handleBundleSelection() {
  const checkedInput = document.querySelector(
    '.bundle-option input[name="bundle-choice"]:checked'
  );

  if (!checkedInput) return;

  const selectedOption = checkedInput.closest('.bundle-option');
  if (!selectedOption) return;

  document.querySelectorAll('.bundle-option').forEach((opt) => {
    opt.classList.remove('active');
  });
  selectedOption.classList.add('active');

  if (selectedOption.classList.contains('subscribe_save')) {
    const wrapper = selectedOption.closest('.variant-wrapper');
    wrapper?.classList.add('subscribe_save_active');
    wrapper?.classList.remove('onetime_active');
  } else if (selectedOption.classList.contains('one_time')) {
    const wrapper = selectedOption.closest('.variant-wrapper');
    wrapper?.classList.remove('subscribe_save_active');
    wrapper?.classList.add('onetime_active');

    const oneTimeDetails = getOneTimePriceDetails();
    if (oneTimeDetails) {
      getOneTimeCustomButton(selectedOption, oneTimeDetails.html, oneTimeDetails.price);
    }
  }
}

/* ============================================================
 * JUICI overrides — injected here because the section file's
 * compile cache and custom.css's minify cache are both stuck.
 * Build: 2026-05-11T17:40
 * ============================================================ */
(function juiciOverrides() {
  // ---------- 1. Inject card-sizing CSS into <head> ----------
  function injectCardSizingCss() {
    if (document.getElementById('juici-card-sizing-css')) return;
    const style = document.createElement('style');
    style.id = 'juici-card-sizing-css';
    style.textContent = `
      .variant-wrapper .swatches.fieldset,
      .product .variant-wrapper .swatches.fieldset {
        justify-content: center !important;
        column-gap: 10px !important;
        row-gap: 10px !important;
        flex-wrap: wrap !important;
      }
      .variant-wrapper .swatches.fieldset input[type=radio] + label,
      .product .variant-wrapper .swatches.fieldset input[type=radio] + label,
      .variant-wrapper .product-form__input:not(.product-form__input--quantity-breaks) input[type=radio]+label {
        flex: 0 1 calc(33.333% - 8px) !important;
        max-width: calc(33.333% - 8px) !important;
        min-width: 0 !important;
      }
      @media (max-width: 600px) {
        .variant-wrapper .swatches.fieldset input[type=radio] + label,
        .product .variant-wrapper .swatches.fieldset input[type=radio] + label,
        .variant-wrapper .product-form__input:not(.product-form__input--quantity-breaks) input[type=radio]+label {
          flex: 0 1 calc(50% - 6px) !important;
          max-width: calc(50% - 6px) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  /* £59.99 price override removed 2026-06-19 */
  // The MutationObserver-based price override (which hardcoded '£59.99' onto the
  // 3-month price elements) has been deleted. Only the card-sizing CSS injection remains.

  function init() {
    injectCardSizingCss();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  [400, 1200, 2500, 5000].forEach((t) => setTimeout(init, t));
})();
